// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import TableCell from "@mui/material/TableCell";

// Vision UI Dashboard PRO React components
import VuiTypography from "components/VuiTypography";
import VuiBox from "components/VuiBox";

function VehicleTypeTableCell({ title, content, image, noBorder, marginTop=0, ...rest }) {
  let template;

  if (image) {
    template = (
      <TableCell {...rest} align="left" width="30%" sx={{ border: noBorder && 0 }}>
        <VuiBox display="flex" alignItems="center" width="max-content" mt={marginTop}>
          <VuiBox component="img" src={image} alt={content} width="1.5rem" height="auto" />{" "}
          <VuiBox display="flex" flexDirection="column" ml={3}>
            <VuiTypography
              variant="caption"
              color="text"
              fontWeight="medium"
              textTransform="capitalize"
            >
              {title}:
            </VuiTypography>
            <VuiTypography
              variant="button"
              color="black"
              fontWeight="medium"
              textTransform="capitalize"
            >
              {content}
            </VuiTypography>
          </VuiBox>
        </VuiBox>
      </TableCell>
    );
  } else {
    template = (
      <TableCell {...rest} align="center" sx={{ border: noBorder && 0 }}>
        <VuiBox display="flex" flexDirection="column">
          <VuiTypography
            variant="caption"
            color="text"
            fontWeight="medium"
            textTransform="capitalize"
          >
            {title}:
          </VuiTypography>
          <VuiTypography
            variant="button"
            fontWeight="medium"
            color="black"
            textTransform="capitalize"
          >
            {content}
          </VuiTypography>
        </VuiBox>
      </TableCell>
    );
  }

  return template;
}

// Setting default values for the props of VehicleTypeTableCell
VehicleTypeTableCell.defaultProps = {
  image: "",
  noBorder: false,
};

// Typechecking props for the VehicleTypeTableCell
VehicleTypeTableCell.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  image: PropTypes.string,
  noBorder: PropTypes.bool,
};

export default VehicleTypeTableCell;
